const settings = [].map((setting) => ({ ...setting }));

export class PropertySettingsModel {
  static get settings() {
    return settings;
  }
}
